import {AnyAction, Reducer} from 'redux';
import {StoreActionsEnum} from "../../../modules/hbs-services";

export const lastPollListLinkReducer: Reducer<any> = (state = null, action: AnyAction = null) => {
    // console.log('storage@lastPollListLinkReducer: action:', action, 'state:', state);

    switch (action.type) {

        case StoreActionsEnum.LAST_POLL_LIST_LINK:
            return action.payload;

        default:
            return state;
    }
};
